/**
 * File conversion utilities
 */

export async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = () => {
      try {
        // For text files, encode content directly
        if (file.type === 'text/plain') {
          const text = reader.result as string;
          const base64 = btoa(unescape(encodeURIComponent(text)));
          resolve(base64);
          return;
        }
        
        // For binary files (PDF, Word)
        const base64 = (reader.result as string).split(',')[1];
        if (!base64) {
          reject(new Error('Falha ao converter arquivo para base64'));
          return;
        }
        resolve(base64);
      } catch (error) {
        reject(new Error('Erro ao converter arquivo para base64'));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Erro ao ler arquivo'));
    };
    
    // Read as base64 for all file types
    reader.readAsDataURL(file);
  });
}